
import cerrar from "../../assets/Back.svg";
import './BackButton.css';
import { useNavigate } from "react-router-dom";

export default function BackButton() {
  const navigate = useNavigate();
  return (
    <div className="yoyo-back-button-wrapper">
      <div className="yoyo-back-button" onClick={() => navigate("/")} text="" icon={cerrar}></div>
      <img src={cerrar} alt="" className="yoyo-back-button__icon" />
    </div>
  );
}
